import React, { useEffect, useMemo, useRef } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import highchartsMore from 'highcharts/highcharts-more';
import solidGauge from 'highcharts/modules/solid-gauge';
import _ from 'lodash';

highchartsMore(Highcharts);
solidGauge(Highcharts);


const constructDataSeries = (data, signalSets, seriesOptions) => {
  const seriesData = [];

  // TODO: remove the loops as we only have one asset and signal
  for (let signalSet of signalSets) {
    for (let signal of signalSet.signals) {
      let signalData;

      signalData = data.find(datum => datum.name === signal.name
        && datum.assetId === signalSet.assetId
        && (!signal.aggregate || datum.aggregate === signal.aggregate));

      seriesData.push({
        // name: assets[signalSet.assetId]?.name ? assets[signalSet.assetId]?.name + ': ' + signal.name : signal.name,
        name: signal.fullName ?? signal.name,
        tooltip: {
          valueDecimals: 2
        },
        data: signalData?.data,
        ...seriesOptions
      });
    }
  }

  return seriesData;
};

const isValidGraphDataPackage = (graphDataPackage) => {
  return graphDataPackage?.signalSets?.length > 0 && graphDataPackage?.data?.length > 0;
};

const CONTAINER_PROPS = {
  style: {
    height: '100%',
    width: '100%'
  }
};

const DialGraphComponent = ({ graphDataPackage, options, reflowTrigger }) => {
  const chartComponent = useRef(null);
  const chartOptions = useMemo(() => {
    let _chartOptions = _.cloneDeep(options);
    if (!isValidGraphDataPackage(graphDataPackage)) {
      _chartOptions.series = {
        name: '',
        data: []
      };
    } else {
      _chartOptions.series = constructDataSeries(
        graphDataPackage.data,
        graphDataPackage.signalSets,
        options.series);
    }

    return _chartOptions;
  }, [graphDataPackage, options]);

  useEffect(() => {
    if (chartComponent.current) {
      const chart = chartComponent.current.chart;
      chart.reflow();
    }
  }, [reflowTrigger]);

  return (
    <HighchartsReact
      ref={chartComponent}
      highcharts={Highcharts}
      options={chartOptions}
      containerProps={CONTAINER_PROPS}
    />
  );
};

export default DialGraphComponent;
